import { i18n, I18nThemeProvider } from "@bb-ui/i18n/dist";
import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import { App, resolveAppProps } from "./App";
import reportWebVitals from "./reportWebVitals";

const appProps = resolveAppProps(document.location.href);

const locale = appProps.locale;
const language = locale.toLowerCase().replace("_", "-");
const supportedLanguages = [
  "ar-sa",
  "az-az",
  "cs-cz",
  "cy-gb",
  "da-dk",
  "de-de",
  "en",
  "en-au",
  "en-gb",
  "en-us-k12",
  "en-us-pro",
  "es-es",
  "fr-ca",
  "fr-fr",
  "he-il",
  "it-it",
  "ja-jp",
  "ko-kr",
  "ms-my",
  "nb-no",
  "nl-nl",
  "nn-no",
  "pl-pl",
  "pt",
  "pt-br",
  "pt-pt",
  "ru-ru",
  "sv-se",
  "th-th",
  "tr-tr",
  "zh-cn",
  "zh-tw",
];

// i18next demands that the non-country-specific languages are added as supported as well, otherwise it will not load
// the country specific language.
supportedLanguages
  .map((countrySpecificLanguage) => countrySpecificLanguage.split("-")[0])
  .forEach((language) => {
    if (supportedLanguages.indexOf(language) === -1) {
      supportedLanguages.push(language);
    }
  });

i18n.init({
  supportedLngs: supportedLanguages,
  whitelist: supportedLanguages,
  fallbackLng: "en",
  lng: language,
  lowerCaseLng: true,
  // Only load the bundle for the requested language. This is to prevent i18next from loading `pt` when `pt-BR` was
  // requested
  load: "currentOnly",
  backend: {
    // points to CRA's default public folder: e.g. /locales/en/translation.json
    loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/translation.json`,
  },
  debug: true,
});
document.body.dir = i18n.i18n.dir();

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback="">
      <I18nThemeProvider theme="light">
        <App {...appProps} />
      </I18nThemeProvider>
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
